import React from 'react';

import DatePicker from 'components/DatePicker';
import { SelectDropDown as SidebarItem } from 'components/Dropdown';

import './Sidebar.scss';

const Sidebar = ({
  mdas,
  subMdas,
  selectedDate,
  setSelectedDate,
  setSelectedMda,
  nameOfSelectedMda,
  nameOfSelectedSubMda,
  handleSearchMdas,
  searchingMdas,
  handleSearchSubMdas,
}) => {
  return (
    <div className='sidebar'>
      <h1 className='sidebar__title'>Filter Budget</h1>
      <div className='sidebar__items-wrapper'>
        <div className='sidebar__items-wrapper__date'>
          <h1>Budget Year</h1>
          <DatePicker
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        </div>
        <SidebarItem
          title='MDA'
          handleSearchMdas={handleSearchMdas}
          mdas={mdas}
          searchingMdas={searchingMdas}
          nameOfSelectedMda={nameOfSelectedMda}
          setSelectedMda={(code, nameOfMda, mdaId) => {
            setSelectedMda(code, 'MDA', nameOfMda, mdaId);
          }}
        />
        <SidebarItem
          title='Sub MDA'
          handleSearchMdas={handleSearchSubMdas}
          mdas={subMdas}
          searchingMdas={searchingMdas}
          nameOfSelectedMda={nameOfSelectedSubMda}
          setSelectedMda={(code, nameOfMda, subMdaId) => {
            setSelectedMda(code, 'sub Mda', nameOfMda, subMdaId);
          }}
          dropDownContainerStyle={{
            top: '250px',
            left: '250px',
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(Sidebar);
